import * as React from 'react';
import { BACKGROUND_COLOR, COLOR_A_HSL, COLOR_B, COLOR_B_HSL, COLOR_A_RGB } from './CONSTANTS';
import { Surface } from 'gl-react-dom'; // for React DOM
import { Shaders, Node, GLSL } from 'gl-react';

class EchoDisplayGL extends React.Component {
	constructor(props) {
		super(props);
		this.wrapperRef = React.createRef();
	}

	render() {
		const { mix, fdbk, time } = this.props;

		return (
			<div style={{ height: '100%', width: '100%' }} ref={this.wrapperRef}>
				{this.wrapperRef.current && (
					<Surface width={this.wrapperRef.current.offsetWidth} height={this.wrapperRef.current.offsetHeight}>
						<GL
							time={performance.now()/1000}
							width={this.wrapperRef.current.offsetWidth}
							height={this.wrapperRef.current.offsetHeight}
							mix={mix}
							fdbk={fdbk}
							delay={time}
						/>
					</Surface>
				)}
			</div>
		);
	}
}

export default EchoDisplayGL;

const shaders = Shaders.create({
	adsr: {
		frag: GLSL`
  precision highp float;
  varying vec2 uv;
  uniform float r,g,b;
  uniform float delay,mix,fdbk;
  uniform float width,height;
  uniform float time;

  float random (in vec2 st) { 
    return fract(sin(dot(st.xy,
                         vec2(12.9898,78.233)))
                 * 43758.5453123);
}

float noise (in vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);

    // Four corners in 2D of a tile
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));

    // Smooth Interpolation

    // Cubic Hermine Curve.  Same as SmoothStep()
    vec2 u = f*f*(3.0-2.0*f);
    // u = smoothstep(0.,1.,f);

    // Mix 4 coorners porcentages
    return a*u.x+(1.-u.x)*b + 
            (c - a)* u.y * (1.0 - u.x) + 
            (d - b) * u.x * u.y;
}

float fbm(in vec2 p){
    float result = noise(p*vec2(1.0,1.0));
	result += 0.5*noise(p*vec2(3.0,2.0));
    result += 0.25*noise(p*vec2(-8.0,8.0));
    result += 0.25*noise(p*vec2(12.0,12.0));
    
    return result;
}


float pattern( in vec2 p )
{
	vec2 q = vec2( fbm( p + vec2(0.1,-time/delay) ),
				   fbm( p + vec2(0.5,0.1) ) );

	vec2 r = vec2( fbm( p + 4.0*q + vec2(0.1,0.52) ),
				   fbm( p + 4.0*q + vec2(8.3,2.8) ) );

	return fbm( p + 1.0*r );
}


  void main() {


	float y=(height/width+uv.y*height/width);
	float x=uv.x;
	vec2 p=vec2(x,y);
	
	 float nd;
	 
	vec2 center = vec2(0.5	,0.15);
	
	float PI=3.141;

	float totalDuration=7.;

	float amnt;

	vec4 cbuff = vec4(0.0);	

	float mag=pow(length(p-center),1.5);
	float mag2=pow(length(p-center),1.);

	nd=abs(mod(mag-time,delay)/delay)*pow(fdbk+0.01,(mag2))*0.5;



	// center = vec2(1,0.15);
	
	// mag=pow(length(p-center),2.);
	// mag2=pow(length(p-center),1.);

	// nd+=abs(mod(mag-time/totalDuration,delay/totalDuration)*totalDuration/delay)*pow(1.-fdbk,(mag2)/(totalDuration/delay));

	// center = vec2(0,0.85);
	
	// mag=pow(length(p-center),2.);
	// mag2=pow(length(p-center),1.);

	// nd+=abs(mod(mag-time/totalDuration,delay/totalDuration)*totalDuration/delay)*pow(1.-fdbk,(mag2)/(totalDuration/delay))*0.5;

	// center = vec2(1,0.85);
	
	// mag=pow(length(p-center),2.);
	// mag2=pow(length(p-center),1.);

	// nd+=abs(mod(mag-time/totalDuration,delay/totalDuration)*totalDuration/delay)*pow(1.-fdbk,(mag2)/(totalDuration/delay))*0.5;

	// center = vec2(0.5,0.5);
	// mag=pow(length(p-center),2.);
	// mag2=pow(length(p-center),1.);


	// nd=nd*smoothstep(0.0,0.5,(1.-nd))*smoothstep(0.5,1.,nd)*2.;

	//nd=abs(sin(PI*(mag-time)/delay));
	// nd=abs(sin((totalDuration/delay)*length(p-center)*PI/2.-(time/delay)))/2.+0.5;
	//float amnt2 = 0.1*1.0/abs((abs(x-0.5)-sqrt(nd)))*0.0005;

	nd=pow(nd,2.);

	
	amnt=nd*pattern(vec2(p*(length(p-center/4.0)))*7.)/10.;
	
	cbuff += vec4((amnt)*0.2, amnt*0.3*y , amnt*y*0.3,0.)*mix*3.0;

	

	gl_FragColor = vec4(cbuff[0]*r,cbuff[1]*g,cbuff[2]*b,1.0);
  }`,
	},
});

class GL extends React.Component {
	render() {
		const { delay, mix,fdbk, width, height,time } = this.props;

		return <Node shader={shaders.adsr} uniforms={{ ...COLOR_A_RGB, time, delay,mix,fdbk, width, height }} />;
	}
}
